import { currentLang } from '@/composables/settings/storage'
import { watch } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = (nuxtApp as any).$i18n

  if (!i18n) return

  // Sync i18n changes back to our custom currentLang ref to keep everything in sync
  // This ensures that API calls and other utilities using currentLang are always up to date
  // Sync i18n changes back to our custom currentLang ref to keep everything in sync
  // ONLY on client to avoid overwriting cookies with default values during SSR boot
  if (import.meta.client) {
    watch(
      () => i18n.locale.value,
      (newLocale) => {
        if (newLocale && currentLang.value !== newLocale) {
          currentLang.value = newLocale
        }
      },
      { immediate: true }
    )
  }

  // On client initialization, ensure currentLang is consistent with i18n locale
  // This handles the case where the cookie was set but i18n didn't pick it up yet
  if (import.meta.client) {
    if (currentLang.value && currentLang.value !== i18n.locale.value) {
      // use setLocale to handle URL prefixing if necessary
      i18n.setLocale(currentLang.value)
    }
  }
})
